import React, { useEffect, useRef, useState } from "react"
import { Link } from "react-router-dom"
import { api } from "../api/client"
import { useLanguage } from "../context/LanguageContext"
import AuthSceneShell, { useAuthSceneParallax } from "../components/AuthSceneShell"

export default function ForgotPassword() {
  const { t } = useLanguage()
  const [email, setEmail] = useState("")
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)
  const [error, setError] = useState("")
  const shapesRef = useRef(null)

  useAuthSceneParallax(shapesRef)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const onSubmit = async (event) => {
    event.preventDefault()
    setError("")
    setLoading(true)
    try {
      await api.forgotPassword({ email })
      setSent(true)
    } catch (exc) {
      setError(exc.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <AuthSceneShell shapesRef={shapesRef}>
      <div className="auth-layout">
        <div className="auth-form-panel">
          <div className="auth-portal-stack w-full max-w-sm mx-auto">
            <h1 className="auth-form-title">{t("forgotPassword")}</h1>

            <div className="auth-panel-3d auth-registration-card auth-portal-card">
              {sent ? (
                <div className="auth-form">
                  <p className="auth-form-hint" role="status">
                    {t("forgotPasswordSent")}
                  </p>
                  <Link to="/login" viewTransition className="button-glow auth-submit">
                    {t("backToSignIn")}
                  </Link>
                </div>
              ) : (
                <form className={`auth-form${loading ? " auth-form--busy" : ""}`} onSubmit={onSubmit}>
                  {error ? (
                    <div className="auth-alert" role="alert">
                      <span className="auth-alert-text">{error}</span>
                      <button
                        type="button"
                        onClick={() => setError("")}
                        className="auth-alert-dismiss"
                        aria-label={t("dismiss")}
                      >
                        ×
                      </button>
                    </div>
                  ) : null}

                  <p className="auth-form-hint">{t("forgotPasswordLead")}</p>

                  <div className="auth-field">
                    <label htmlFor="email">{t("email")}</label>
                    <input
                      id="email"
                      name="email"
                      type="email"
                      required
                      autoComplete="email"
                      value={email}
                      onChange={(event) => setEmail(event.target.value)}
                      className="auth-input"
                    />
                  </div>

                  <button type="submit" disabled={loading} aria-busy={loading} className="button-glow auth-submit">
                    {loading ? `${t("sendingReset")}…` : t("forgotPasswordSubmit")}
                  </button>
                </form>
              )}

              <div className="auth-form-footer">
                <p>
                  <Link to="/login" viewTransition className="auth-text-link">
                    {t("backToSignIn")}
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AuthSceneShell>
  )
}
